var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { toaster } from "@pga/toast";
import { useState } from "react";
import Captcha from "./../service/services";
export const useCaptcha = (url, loginUrl) => {
    const [value, setValue] = useState("");
    const [resData, setResData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const getCaptcha = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setIsLoading(true);
            const res = yield Captcha.GetCaptcha(url, loginUrl);
            if (res.success) {
                setValue("");
                setResData(res.data);
            }
            else {
                toaster("error", res.messages);
            }
        }
        catch (e) {
            console.log(`~~~ error in useCapthca api: ${e}`);
        }
        finally {
            setIsLoading(false);
        }
    });
    const id = (resData === null || resData === void 0 ? void 0 : resData.id) || null;
    return { value, setValue, id, isLoading, getCaptcha, resData };
};
